import api from "@/api";

const detailedMapPlace = {
    place: {
        uid: 0,
        name: '',
        address: '',
        photo_url: '',
        my_rates_count: 0,
        rates_info: {
            rate1: 0,
            rate2: 0,
            rate3: 0,
        }
    }
}

export default {
    namespaced: true,

    state: {
        detailedPlace: JSON.parse(JSON.stringify(detailedMapPlace)),
        myPlaceChekbox: true,
        page: 1,
        rates: [],
        isCompleteInfinityList: false,
        sites: [],
    },

    mutations: {
        setDetailedMapPlace(state, place) {
            const detailedPlace = place ? place : JSON.parse(JSON.stringify(detailedMapPlace))
            state.detailedPlace = detailedPlace
        },

        setChekboxPlaceType(state, place) {
            state.myPlaceChekbox = place
        },

        setPlacePage(state, page) {
            state.page = page
        },

        setRates(state, sites) {
            state.sites = sites
        },

        addRates(state, sites) {
            state.sites.push(sites)
        },

        setCompleteInfinityList(state, value) {
            state.isCompleteInfinityList = value
        },

        removePlace(state, place) {
            const index = state.sites.findIndex(item => item === place)
            state.sites.splice(index, 1)
        },

    },

    actions: {
        async getDetailPlace(context, placeId) {
            const url = `/api/v1/detailedPlace?place_id=${placeId}`;
            try {
                return await api.request("get", url);
            } catch (error) {
                throw error;
            }
        },

        async fetchPlace(context, placeId) {
            const sessionToken = context.rootState.sessionToken ? `&session_token=${context.rootState.sessionToken}` : ''
            const url = `/api/v1/placeByGoogleId?place_id=${placeId}${sessionToken}`;

            try {
                const response = await api.request("get", url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async createPlace(context, placeId) {
            const url = `/api/v1/addPlace?place_id=${placeId}`;
            try {
                const response = await api.request("get", url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async deletePlace(context, place) {
            const url = `/admin/places/${place.uid}`;
            try {
                const response = await api.request("delete", url);
                context.commit('removePlace', place)
                return response
            } catch (error) {
                throw error.data.error
            }
        },

        async fetchPinPlaces(context, {rightTopLat, rightTopLng, leftBottomLat, leftBottomLng}) {
            let url = `/api/v1/mapPinPlaces?`
            url += `rightTopLat=${rightTopLat}`
            url += `&rightTopLng=${rightTopLng}`
            url += `&leftBottomLat=${leftBottomLat}`
            url += `&leftBottomLng=${leftBottomLng}`

            try {
                const response = await api.request("get", url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async fetchSimpleDetailetPlace(context, placeId) {
            const url = `/api/v1/mapCardPlace?place_id=${placeId}`;
            try {
                const response = await api.request("get", url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async fetchPlacesList(context, {isMyPlaces, page, searchText, get_all}) {
            const placeType = isMyPlaces ? "myPlaces" : "places";
            const search = searchText ? `&search=${encodeURIComponent(searchText)}` : ''
            const getAll = get_all ? `&get_all=${get_all}` : ''
            const url = `/api/v1/${placeType}?page=${page}${search}${getAll}`;

            try {
                const response = await api.request("get", url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async getPlacesList(context, obj) {
            const data = {
                search: obj.search,
                order_by: obj.order_by,
                order_dir: obj.order_dir,
                get_all: obj.get_all,
                page: obj.page
            }
            const url = `/admin/sites`
            try {
                const response = await api.request('post', url, data)
                return response.data;
            } catch (error) {
                throw error
            }
        },

        async connectOwnerToPlace(context, site) {
            const url = '/api/v1/ownPlace'

            try {
                const response = await api.request("post", url, site);
                return response.data;
            } catch (error) {
                throw error;
            }

        },
        async fetchSecondLevelConfig(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/secondLevelConfig`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async fetchServiceLogConfig(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/serviceLogConfig`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async saveSecondLevelConfig(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/addSecondLevelConfig`
            try {
                const response = await api.request("put", url, obj)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async saveServiceLogConfig(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/addServiceLogConfig`
            try {
                const response = await api.request("put", url, obj)
                return response.data
            } catch (e) {
                throw e
            }
        },
    }
};
